<script setup>
import { useTheme } from 'vuetify'

const props = defineProps({
  enabled: { type: Boolean, default: false },
})

defineEmits(['show-longpos-overlay'])

const theme = useTheme()
</script>

<template>
  <v-chip
    class="px-4"
    prepend-icon="mdi-grid"
    :append-icon="props.enabled ? 'mdi-check-circle' : undefined"
    variant="elevated"
    :color="props.enabled ? 'primary' : theme.current.value.colors.surface"
    @click="$emit('show-longpos-overlay')"
  >
    {{ $t('canvas.settings.overlay.long_pos.title') }}
  </v-chip>
</template>
